<template>
  <article class="flex flex-col space-y-4 lg:space-y-6">
    <!-- Page header -->
    <div class="relative overflow-hidden">
      <div class="max-h-[700px] h-full min-h-[150px] z-[1] relative flex">
        <img
          class="mx-auto object-cover object-center aspect-[5/2] min-w-0 w-full max-w-[1568px]"
          :aspect="5 / 2"
          src="/assets/publish/publishbanner.png"
          alt="contest-header"
        />
      </div>
      <div
        class="absolute inset-0 brightness-50 bg-gradient-to-b from-neutral-500"
      ></div>
    </div>
    <div class="sm:px-4 lg:px-8">
      <div class="container flex flex-col gap-4 pt-4 lg:gap-6 lg:pt-6">
        <LegacyPageProfileTabs v-bind="tabs" />

        <NuxtPage keepalive />
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
const nuxtApp = useNuxtApp();
const { locale, t: translate } = useI18n();
const mappedLocale = computed(() => reverseLocaleMap(locale.value));

const tabs = ref({
  tabs: {
    current: "",
    default: "overview",
    rootPath: `/${mappedLocale.value}/publish`,
    items: [
      { name: translate("site.publish.tabOverview"), slug: "overview" },
      //{ name: translate("site.publish.tabResources"), slug: "resources" },
      { name: translate("site.publish.tabMonetization"), slug: "makemoney" },
    ],
  },
});

const bgBanner = computed(
  () => `url(${getAbsoluteAssetLink("assets/publish/publishbanner.png")})`,
);
</script>

<style scoped lang="postcss">
.bg-filler {
  z-index: 0;
  @apply absolute -inset-8;

  &:after {
    content: "";
    z-index: 0;
    filter: blur(24px) brightness(50%);
    background-color: #888888;
    background-image: v-bind(bgBanner);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    @apply inset-0 block absolute;
  }
}
</style>
